import { fetchPersea } from "@/config/axios/config-axios";


export const getCampaignMissionProgressCount = async (params = {}) => {
    return await fetchPersea(`campaign/mission/objective/progress/count`, 'GET', params);
};